// @flow

import { useContext } from 'react';
import { type FormStatusContextType } from './types';
import { FormStatusContext } from './context';

export function useFormStatusContext(): FormStatusContextType {
  const context = useContext(FormStatusContext);
  if (context) {
    return context;
  }
  throw new Error('FormStatusContext was not provided');
}
